import React, {Component } from 'react';
import {connect} from 'react-redux';

import CompareText from "./CompareText";
import CompareFile from "./CompareFile";
import {verifyClient, compare, acceptTerms, checkProgress, setsendByEmailJSA, setEmail, askForDonation,showBackgroundvideo} from "../reducers/files";
import {ComparisonSourceTypes, InputTypes, backendServerURLone,errorconection} from "../reducers/store";
import PropTypes, {bool} from 'prop-types';
import {Report} from './Report';
import Loader from 'react-loader-spinner';
import Loaderspiner from './Loaderspiner';
import ProgressInfo from './ProgressInfo';
import Iframeyoutube from './Iframeyoutube';
import Getreport from './Getreport';
import {Links1} from "./Links1";
import {Links2} from "./Links2";






class ComparisonForm extends Component {
 
  static defaultProps={
    textorfile:false,
    comparedone:false,
    showrepotrt:false,
    servernotfine:false,
    tryserverbackground:true,
    check_server_clarin_id:String,
    isIncognitotest:false
  
  }
  state={
    textorfile:this.props.textorfile,
    comparedone:this.props.comparedone,
    showrepotrt:this.props.showrepotrt,
    servernotfine:this.props.servernotfine,
    tryserverbackground:this.props.tryserverbackground,
    check_server_clarin_id:this.props.check_server_clarin_id,
    isIncognitotest:this.isIncognitotest
    
    
    
  }
 
 //sprawdzenie czy serwer dziala
 set_error_clarin(){

 }
 
check_server_clarin(){
  const params_clarin={ "lpmn": "any2txt|maca({\"morfeusz2\":true})",
  "text": "test",
  "application": "ws.clarin-pl.eu",
  "user": "demo"};
  fetch('https://ws.clarin-pl.eu/nlprest2/base/startTask'
  , 
  {
    method: "POST", 
    body: JSON.stringify(params_clarin),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      
    },
   
  }).then(async res=>
    { if (res.status === 200) {
      let id=await res.text();
      this.setState({check_server_clarin_id:id});
        }  else{
          this.setState({servernotfine:true});
          this.setState({tryserverbackground:true});
        } 
       })
  
  
  .catch((error) => {
    
    console.error('Error:', error);
    this.setState({servernotfine:true});
    
  });
 
  }
  async componentDidMount () {
    
      fetch(`${backendServerURLone}/about`)
        .then((res) => {
          
          if (res.status === 200) {
            this.setState({servernotfine:false});
            this.setState({tryserverbackground:false});
              }  else{
                this.setState({servernotfine:true});
                this.setState({tryserverbackground:true});
              } 
        })
        .catch((error) => {
          
          console.error('Error:', error);
          this.setState({servernotfine:true});
          
        });
               
      
    const {pathreturnpage}=this.props
    
    this.props.verifyClient();
    //this.check_server_clarin();

    
   
    
    //console.log(pathreturnpage);

  }
  //przycisk platnosci
  componentDidUpdate () {
    const {transactionId, inProgress, checkProgress, clientId, tryDemo,compareview, report, donate, askForDonation,showBackgroundvideo} = this.props;
    
    if(transactionId)
    {
      showBackgroundvideo(compareview);
    }
    if (inProgress) {
      
      if(tryDemo)
        {
          showBackgroundvideo(compareview);
        }
   
      checkProgress({transactionId, clientId, tryDemo,});
    } else if (report && donate === null) {
      askForDonation();
      
    }
  }

  //zmiana na raport
 showrepotrt = () => {
    this.setState({showrepotrt:true});
     
      
  }
  
  accept = () => {
    const {acceptedTerms, acceptTerms} = this.props;
    acceptTerms(!acceptedTerms);
  }
  
  setsendByEmailJSA = () => {
    const {sendByEmailJSA, setsendByEmailJSA} = this.props;
    setsendByEmailJSA(!sendByEmailJSA);
  }
  
  setEmail = ({target}) => {
    const {value} = target;
    const {setEmail} = this.props;
    setEmail({email: value});
  }
 
  render () {
    const {demoAvailable, demoAllowed, originalSource, userSource, compare, inProgress, email, wrongEmail, unitAmount,
       report, processing,compareview, paid, acceptedTerms, isAdmin, sendByEmailJSA, taxAmount, unitPrice, specialOffer,freeDemoCharLimit} = this.props;
   const{showrepotrt,comparedone,servernotfine,tryserverbackground}=this.state;
   
   
    //ustawianie ceny usuniete z props: , paid ,  freeDemoCharLimit , userSource.wordCount ? 1 : 0
    let startingprice=0;
    if(originalSource.wordCount !==0 || userSource.wordCount !==0)
    {
      startingprice=10;
    }
    const price = startingprice+Math.max(((originalSource.wordCount + userSource.wordCount) / unitAmount) * unitPrice) * (1 + taxAmount);
    let compareAllowed = true;
   
   
    //sprawdzenie poprawnosci plikow
    if (!originalSource.inputType ||
      (originalSource.inputType === InputTypes.FILE && !originalSource.filename) ||
      (originalSource.inputType === InputTypes.TEXT && !originalSource.content)) {
      compareAllowed = false;
    }
    if (!userSource.inputType ||
      (userSource.inputType === InputTypes.FILE && !userSource.filename) ||
      (userSource.inputType === InputTypes.TEXT && !userSource.content)) {
      compareAllowed = false;
    }
    //if(userSource.inputType !== originalSource.inputType){compareAllowed = false;}
    //dodanie końcówek do liczby slow 
    let chartCountSuffix = 'ów';
    if (userSource.wordCount === 1) {
      chartCountSuffix = 'owo';
      // eslint-disable-next-line no-mixed-operators 
      // zmaiana na slowa dla 2,3 i 4
    } else if (userSource.wordCount && (userSource.wordCount < 5 || (userSource.wordCount > 21 && ['2', '3', '4'].some(c => userSource.wordCount.toString().endsWith(c))))) {
      chartCountSuffix = 'owa';
    }
  
    return         (report && showrepotrt) ? [
      
      <Report key={10}/>,
      <Links2 key={11}/>
    ] : [ tryserverbackground?<div className="checkingserver" key={9}>.</div>:'',
      servernotfine ?[
      <div className="checkingserver" key={9}>
      <div class="errorservermesege">
        {errorconection}
      </div>
      </div>

    ]:[ //uruchomienie demo i specialnych ofert
    
      ...demoAvailable && !specialOffer ? [
        <div className="default-block container" key={0}>
          <h2 style={{textAlign: 'center', fontWeight: 600, marginBottom: 60}}>Przetestuj za darmo <span style={{color: '#F54D4D'}}>{freeDemoCharLimit}</span> znaków. </h2>
        </div>
      ] : [],
  
      ...specialOffer ? [
        <div className="default-block container" key={1} style={{textAlign: 'center'}}>
          <h2 style={{fontWeight: 600}}>Porównaj za darmo!</h2>
          <h4><span style={{color: 'rgb(245, 77, 77)', marginBottom: 60}}>Wesprzyj rozwój programu! Dla przyszłych roczników</span><br/>
            Wpłać dowolną kwotę, a my przeznaczymy ją na dalszy rozwój systemu</h4>
        </div>
      ] : [],
//okno plikow do przeslania zamian okienek
      <div className="default-block container" key={2}>
   
      <div id="toinsertcompardiv" >
       <div className="toinsertdatacolumnfirst">
        
             <CompareText sourceType={ComparisonSourceTypes.USER} textorfile={null} label={'true'}/> 
            <CompareFile  sourceType={ComparisonSourceTypes.USER} textorfile={null} label={'true'}/>
            </div>
            <div className="toinsertdatacolumnsecond">
           
              <CompareText sourceType={ComparisonSourceTypes.ORIGINAL} textorfile={originalSource.inputType}  secondLabel={'true'}/> 
              <CompareFile sourceType={ComparisonSourceTypes.ORIGINAL} textorfile={originalSource.inputType} secondLabel={'true'}/>
            </div>
      </div>
			
		
      </div>,
    //podsumowanie liczbowe unitAmount && 
      <div className="default-block container" style={{  display: 'flex',flexDirection: 'row',  justifyContent: 'center'}} key={3}>
        <h2 style={{textAlign: 'center', fontWeight: 600, marginTop: 90, marginBottom: 50}}>Twoja praca liczy <span style={{color: '#F54D4D'}}>{userSource.wordCount || 0} sł{chartCountSuffix}.</span><br/>
          Koszt weryfikacji {demoAllowed ? 'wyniósłby' : 'wyniesie'} <span style={{color: '#F54D4D'}}>{price.toFixed(2)} zl</span>
          <br/><span style={{fontSize: '80%' }}>(plus ewentualna prowizja banku)</span>
        </h2>
      </div>,
    //sprawdzenie zaznaczenia regulaminu
     // pole do zaznaczenia czy chcemy otrzymac raport emailem 
      <div className="default-block container" style={{textAlign: 'center', padding: '0 15%', width: 'auto'}} key={5}>
        <div className="wp-block-columns" style={{alignItems: 'center', marginBottom: 0}}>
          <div className="default-block container" style={{marginBottom: 20}}>
            <div className="wp-block-column">
              <label htmlFor="accept" style={{color: '#A6ABB5'}}>
                <input id="accept" type="checkbox" checked={acceptedTerms} disabled={processing || inProgress} onChange={this.accept}/>
                Akceptuję
              </label> <a target="_blank" rel="noopener noreferrer" href="http://www.poprawaprac.pl/regulamin-jsa-demo">warunki</a>
            </div>
          </div>
          
          <div className="default-block container" style={{marginBottom: 20}}>
            <div className="wp-block-column">
              <label htmlFor="sendByEmailJSA" style={{color: '#A6ABB5'}}>
                <input id="sendByEmailJSA" type="checkbox" checked={sendByEmailJSA} disabled={processing || inProgress} onChange={this.setsendByEmailJSA}/>
                Chcę otrzymać raport mailem
              </label>
            </div>
          </div>
        
          <div className="default-block container" style={{marginBottom: 20}}>
            <div className="wp-block-column">
              <input value={email || ''}
                     onChange={this.setEmail}
                     placeholder="Podaj adres e-mail"
                     {...!sendByEmailJSA && {
                       style: {color: '#ccc'}
                     }}
                     {...wrongEmail && {
                       title: 'Ten e-mail adres jest niepoprawny'
                     }}
                     className={`send-to-email ${wrongEmail && sendByEmailJSA ? 'wrong-email' : ''}`}
                     disabled={processing || inProgress || !sendByEmailJSA}/>
            </div>
          </div>
        </div>
      </div>,
    //przycis przetestuj  zmiany : podmieniony przycisk poprawic na admin demo itp
      /*<div className="default-block container" key={6}>
        <div className="wp-block-buttons" style={{textAlign: 'center'}}>
          <div className="default-block container" style={{width: 'auto'}}>
            {demoAvailable || isAdmin || specialOffer ? <div className="wp-block-button">
              <button className="wp-block-button__link"
                      style={{borderRadius: 5, backgroundColor: '#25376B'}}
                      disabled={!compareAllowed || ((!demoAllowed || !demoAvailable) && !isAdmin) || processing || !acceptedTerms || inProgress || (sendByEmailJSA && (!email || wrongEmail))}
                      onClick={() => {
                        this.changetocompare();
                        compare(isAdmin ? {} : {tryDemo: true});
                        localStorage.removeItem('Y2xpZW50SWQ=');
                      }}>
                      Przetestuj</button>
            </div> : ''}
  
            {(!demoAllowed || !demoAvailable) && !specialOffer ? <div className="wp-block-button">
            <button className="wp-block-button__link"
                      style={{borderRadius: 5, backgroundColor: '#25376B'}}
                      disabled={!compareAllowed || processing || !acceptedTerms || inProgress}
                      onClick={
                        compare
                      }> z platnoscia</button>
            </div> : ''}
          </div>
        </div>
      </div>,
    // na oczekiwanie isAdmin ? {} : {tryDemo: true}*/
    <div className="default-block container" key={6}>
        <div className="wp-block-buttons" style={{textAlign: 'center'}}>
          <div className="default-block container" style={{width: 'auto'}}>
                      
            {demoAvailable && !isAdmin && demoAllowed  ? <div className="wp-block-button">
              <button className="wp-block-button__link"
                      style={{borderRadius: 5, backgroundColor: '#25376B'}}
                      disabled={!compareAllowed ||  processing || !acceptedTerms || inProgress }
                      onClick={() => {
                        compare({tryDemo: true});
                       
                      }}>Przetestuj</button>
            </div> : ''}
          
            {(!isAdmin  && !demoAvailable) || !demoAllowed ? <div className="wp-block-button">
              <button className="wp-block-button__link has-white-color has-text-color has-background compare-button"
                      style={{borderRadius: 5, backgroundColor: '#f54d4d'}}
                      disabled={!compareAllowed || processing || !acceptedTerms || inProgress}
                      onClick={() =>{
                              compare({tryDemo:false});
                             
                              }}>
                {paid ? 'Porównaj' : 'Dokonaj płatności'}
              </button>
            </div> : ''}
            {isAdmin ? <div className="wp-block-button">
              <button className="wp-block-button__link has-white-color has-text-color has-background compare-button"
                      style={{borderRadius: 5, backgroundColor: '#f54d4d'}}
                      disabled={!compareAllowed || processing  || inProgress}
                      onClick={() =>{
                              compare({tryDemo:false});
                            
                              }}>
                Wykonaj Raport
              </button>
              { isAdmin  ? [<Getreport key={12}/> ] : [''] }
            </div> : ''}
          </div>
        </div>
      </div>,
    
      <div  key={9}>
        
        {(compareview && !showrepotrt) ?
             [<div className="progressreenvideo" key={9}>
               <div className="progressreenvideotext" key={9} >       
                 {(comparedone || report) ? 
                    [ <button id="buttoncomap" 
                     onClick={() => {
                     this.showrepotrt();
                            }}
                     key={8} >Raport jest gotowy. </button>]:
                     [ 
                              <div className="progresinfo" key={7}>
                          <ProgressInfo  />
                         <Loaderspiner />
                      </div>]}
               </div>
               <Iframeyoutube key={10}/>
              </div>     
                                           ] : [] }
       {(inProgress && !compareview) ? 
          [ <div className="progressreen" key={10}> 
              
                  <Loader
                  type="Oval"
                  color="white"
                  height={100}
                  width={100}
                  className="jsa-loader"
                />
            </div>



          ] :[]}
      </div>,
    
      <Links1 key={10}/>
    ]]
  }
}

ComparisonForm.propTypes = {
  demoAvailable: PropTypes.bool,
  demoAllowed: PropTypes.bool,
  userSource: PropTypes.object,
  originalSource: PropTypes.object,
  verifyClient: PropTypes.func,
  compare: PropTypes.func,
  paid: PropTypes.bool,
  freeDemoCharLimit: PropTypes.number,
  charCount: PropTypes.number,
  report: PropTypes.object,
  processing: PropTypes.bool,
  acceptTerms: PropTypes.func,
  acceptedTerms: PropTypes.bool,
  pathreturnpage: PropTypes.string,
  inProgress: PropTypes.bool,
  transactionId: PropTypes.string,
  checkProgress: PropTypes.func,
  showBackgroundvideo: PropTypes.func,
  clientId: PropTypes.string,
  tryDemo: PropTypes.bool,
  isAdmin: PropTypes.bool,
  setsendByEmailJSA: PropTypes.func,
  sendByEmailJSA: PropTypes.bool,
  setEmail: PropTypes.func,
  email: PropTypes.string,
  wrongEmail: PropTypes.bool,
  unitAmount: PropTypes.number,
  unitPrice: PropTypes.number,
  taxAmount: PropTypes.number,
  specialOffer: PropTypes.bool,
  donate: PropTypes.bool,
  askForDonation: PropTypes.func,
  textorfile:  PropTypes.bool,
  comparedone: PropTypes.bool,
  showrepotrt: PropTypes.bool,
  compareview: PropTypes.bool,
  changetocompare: PropTypes.func,
  tryserverbackground:PropTypes.bool
 
};

ComparisonForm.defaultProps = {
  demoAvailable: true,
  demoAllowed: true,
  userSource: {},
  originalSource: {},
  verifyClient: () => {},
  compare: () => {},
  paid: false,
  acceptTerms: () => {},
  acceptedTerms: false,
  checkProgress: () => {},
  showBackgroundvideo: () => {},
  changetocompare: () => {},
  tryDemo: false,
  isAdmin: false,
  setsendByEmailJSA: () => {},
  sendByEmailJSA: false,
  setEmail: () => {},
  wrongEmail: bool,
  specialOffer: false,
  askForDonation: () => {},
  textorfile:false ,//showtext
  showrepotrt:false,
  comparedone:false,
  confirmreport:false,
  tryserverbackground:true

}

export default connect(
  ({demoAvailable, demoAllowed, originalSource,comparedone, userSource, paid, freeDemoCharLimit, tryDemo, isAdmin, email, unitAmount, unitPrice, taxAmount,
     charCount, report, processing,compareview, acceptedTerms,pathreturnpage, inProgress, transactionId, clientId, sendByEmailJSA, wrongEmail, specialOffer, donate}) => ({
    specialOffer,
    unitAmount,
    unitPrice,
    taxAmount,
    wrongEmail,
    comparedone,
    email,
    sendByEmailJSA,
    isAdmin,
    transactionId,
    pathreturnpage,
    inProgress,
    acceptedTerms,
    compareview,
    processing,
    report,
    charCount,
    paid,
    userSource,
    originalSource,
    demoAvailable,
    demoAllowed,
    freeDemoCharLimit,
    clientId,
    tryDemo,
    donate,
    
    
  }),
  {verifyClient, compare, acceptTerms, checkProgress, showBackgroundvideo, setsendByEmailJSA, setEmail, askForDonation}
)(ComparisonForm);
